import axios from "axios";

// Dynamically determine API URL based on current hostname
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Production: served through nginx reverse proxy (default port)
  if (!window.location.port || window.location.port === '80' || window.location.port === '443') {
    return '/api';
  }
  // Local development: connect directly to backend
  return `http://${window.location.hostname}:8000`;
};

const api = axios.create({
  baseURL: getApiUrl(),
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
  timeout: 60000,
});

// For FormData uploads, remove the default Content-Type so the browser
// can set the correct multipart/form-data boundary automatically.
api.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    config.headers.delete("Content-Type");
  }
  return config;
});

// Redirect to login on 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (!window.location.pathname.startsWith("/login")) {
        const detail = error.response?.data?.detail;
        if (detail === "inactive_timeout") {
          sessionStorage.setItem("session_message", "You have been logged out due to 4 hours of inactivity. Please log in again.");
        } else if (detail === "new_day_expired") {
          sessionStorage.setItem("session_message", "Your session has expired for the new day. Please log in again.");
        } else if (detail === "session_revoked") {
          sessionStorage.setItem("session_message", "Your session was ended because your account was logged in from another device.");
        }
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
